<template>
    <div class="menu">
        <div class="menu-logo">
            <div class="info-box">
                <img src="../assets/elm.png">
                Laignoranciadamiedo@gmail.com
            </div>
            <div class="info-box">
                <img src="../assets/tel.png">
                976102938
            </div>
            <div class="info-box">
                <img src="../assets/add.png" alt="">
                AV. GUARDIA PERUANA NRO. 669 URB. PASEO DE LA
            </div>
        </div>
        <div class="menu-logo-box">
            <div class="logo-box">
                <img src="../assets/logo.png" alt="">
                <span>PERUVIAN</span> SHELL S.A.C.
            </div>

            <div class="menu-box">
                <div class="item" :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">Home </div>
                <div class="item" :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">About us</div>
                <div class="item" :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">Services</div>
                <div class="item" :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">Contacts us</div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    name: "Menu",
    props: {
        step: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            index: 0
        };
    },
    methods: {
        selectMenu(value) {
            this.index = value
            if (value == this.step) {
                return
            }
            switch (value) {
                case 1: this.$router.push({ path: "/" }); break;
                case 2: this.$router.push({ path: "AboutUs" }); break;
                case 3: this.$router.push({ path: "Service" }); break;
                case 4: this.$router.push({ path: "ContactUs" }); break;
                // case 5: this.$router.push({ path: "aboutUs" }); break;
                // case 5: this.$router.push({ path: "cooperate" }); break;
                default: this.$router.push({ path: "/" }); break;
            }
        }
    }
}
</script>
<style lang="less" scoped>
.menu {
    .menu-logo {
        padding: 0px 360px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #fff;


        .info-box {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-weight: 400;
            font-size: 16px;
            color: #fff;
            width: 300px;

            img {
                margin-right: 10px;
                width: 40px;
            }
        }
    }

    .menu-logo-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 360px;
        margin-top: 10px;

        .logo-box {
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 800;
            font-size: 26px;
            color: #FFF;

            img {
                width: 60px;
                margin-right: 14px;
            }

            span {
                color: #FFA72C;
            }
        }

        .menu-box {
            display: flex;
            font-size: 18px;
            font-weight: 500;
            color: #fff;
            cursor: pointer;
            // height: 60px;
            // line-height: 80px;

            .item {
                padding: 0px 10px;
                margin-right: 50px;
            }
        }
    }



    .select {
        color: #FFA72C;
        border-bottom: 4px solid #FFA72C;
        font-weight: bolder;
    }
}
</style>